import { render, staticRenderFns } from "./GovernanceWarningBanner.vue?vue&type=template&id=afeefa6e&scoped=true"
import script from "./GovernanceWarningBanner.vue?vue&type=script&lang=js"
export * from "./GovernanceWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./GovernanceWarningBanner.vue?vue&type=style&index=0&id=afeefa6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeefa6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afeefa6e')) {
      api.createRecord('afeefa6e', component.options)
    } else {
      api.reload('afeefa6e', component.options)
    }
    module.hot.accept("./GovernanceWarningBanner.vue?vue&type=template&id=afeefa6e&scoped=true", function () {
      api.rerender('afeefa6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/governance/components/GovernanceWarningBanner.vue"
export default component.exports